import ShareScreen from './ShareScreen';

export default ShareScreen;
